var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 565,
    zoomAndPan: "magnify",
    viewBox: "0 0 423.75 262.499992",
    height: 350,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ea9cb2f052"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.277344 0 L 423.222656 0 L 423.222656 262 L 0.277344 262 Z M 0.277344 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea5b710680"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 241 L 423.222656 241 L 423.222656 262 L 3 262 Z M 3 241 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0ac5c8d5ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 221 L 423.222656 221 L 423.222656 242 L 3 242 Z M 3 221 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "01f3618ba0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 201 L 423.222656 201 L 423.222656 222 L 3 222 Z M 3 201 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f0a175561a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 181 L 423.222656 181 L 423.222656 202 L 3 202 Z M 3 181 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3169473be1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 161 L 423.222656 161 L 423.222656 182 L 3 182 Z M 3 161 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c652717699"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 140 L 423.222656 140 L 423.222656 162 L 3 162 Z M 3 140 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc91125d79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 120 L 423.222656 120 L 423.222656 141 L 3 141 Z M 3 120 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "63246afffb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 100 L 423.222656 100 L 423.222656 121 L 3 121 Z M 3 100 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0367be06d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 80 L 423.222656 80 L 423.222656 101 L 3 101 Z M 3 80 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "596ecac930"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 60 L 423.222656 60 L 423.222656 81 L 3 81 Z M 3 60 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6597e081b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 40 L 423.222656 40 L 423.222656 61 L 3 61 Z M 3 40 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e6038e8b14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 20 L 423.222656 20 L 423.222656 41 L 3 41 Z M 3 20 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6262284c93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 0 L 423.222656 0 L 423.222656 21 L 3 21 Z M 3 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea9cb2f052)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.277344 0 L 423.222656 0 L 423.222656 262 L 0.277344 262 Z M 0.277344 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.277344 0 L 423.222656 0 L 423.222656 262 L 0.277344 262 Z M 0.277344 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea5b710680)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb001c",
    d: "M 3.472656 241.589844 L 451.859375 241.589844 L 451.859375 261.703125 L 3.472656 261.703125 Z M 3.472656 241.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ac5c8d5ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.472656 221.457031 L 451.859375 221.457031 L 451.859375 241.589844 L 3.472656 241.589844 Z M 3.472656 221.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#01f3618ba0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb001c",
    d: "M 3.472656 201.332031 L 451.859375 201.332031 L 451.859375 221.457031 L 3.472656 221.457031 Z M 3.472656 201.332031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f0a175561a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.472656 181.179688 L 451.859375 181.179688 L 451.859375 201.332031 L 3.472656 201.332031 Z M 3.472656 181.179688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3169473be1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb001c",
    d: "M 3.472656 161.066406 L 451.859375 161.066406 L 451.859375 181.179688 L 3.472656 181.179688 Z M 3.472656 161.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c652717699)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.472656 140.941406 L 451.859375 140.941406 L 451.859375 161.066406 L 3.472656 161.066406 Z M 3.472656 140.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc91125d79)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb001c",
    d: "M 3.472656 120.808594 L 451.859375 120.808594 L 451.859375 140.941406 L 3.472656 140.941406 Z M 3.472656 120.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#63246afffb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.472656 100.664062 L 451.859375 100.664062 L 451.859375 120.789062 L 3.472656 120.789062 Z M 3.472656 100.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0367be06d3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb001c",
    d: "M 3.472656 80.53125 L 451.859375 80.53125 L 451.859375 100.664062 L 3.472656 100.664062 Z M 3.472656 80.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#596ecac930)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.472656 60.390625 L 451.859375 60.390625 L 451.859375 80.523438 L 3.472656 80.523438 Z M 3.472656 60.390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6597e081b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb001c",
    d: "M 3.472656 40.273438 L 451.859375 40.273438 L 451.859375 60.390625 L 3.472656 60.390625 Z M 3.472656 40.273438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e6038e8b14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.472656 20.132812 L 451.859375 20.132812 L 451.859375 40.265625 L 3.472656 40.265625 Z M 3.472656 20.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6262284c93)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb001c",
    d: "M 3.472656 0 L 451.859375 0 L 451.859375 20.132812 L 3.472656 20.132812 Z M 3.472656 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2a3560",
    d: "M 3.472656 0 L 208.183594 0 L 208.183594 140.941406 L 3.472656 140.941406 Z M 3.472656 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.941406 15.527344 L 23.664062 20.863281 L 29.253906 20.863281 L 24.734375 24.144531 L 26.460938 29.484375 L 21.941406 26.171875 L 17.402344 29.484375 L 19.136719 24.144531 L 14.609375 20.863281 L 20.199219 20.863281 Z M 21.941406 15.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.941406 39.054688 L 23.664062 44.382812 L 29.253906 44.382812 L 24.734375 47.679688 L 26.460938 53.003906 L 21.941406 49.707031 L 17.402344 53.003906 L 19.136719 47.679688 L 14.609375 44.382812 L 20.199219 44.382812 Z M 21.941406 39.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.941406 62.578125 L 23.664062 67.898438 L 29.253906 67.898438 L 24.734375 71.195312 L 26.460938 76.519531 L 21.941406 73.222656 L 17.402344 76.519531 L 19.136719 71.195312 L 14.609375 67.898438 L 20.199219 67.898438 Z M 21.941406 62.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.941406 86.109375 L 23.664062 91.433594 L 29.253906 91.433594 L 24.734375 94.726562 L 26.460938 100.035156 L 21.941406 96.757812 L 17.402344 100.035156 L 19.136719 94.726562 L 14.609375 91.433594 L 20.199219 91.433594 Z M 21.941406 86.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.941406 109.628906 L 23.664062 114.949219 L 29.253906 114.949219 L 24.734375 118.25 L 26.460938 123.570312 L 21.941406 120.289062 L 17.402344 123.570312 L 19.136719 118.25 L 14.609375 114.949219 L 20.199219 114.949219 Z M 21.941406 109.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 38.320312 27.929688 L 40.035156 33.25 L 45.625 33.25 L 41.105469 36.546875 L 42.828125 41.875 L 38.320312 38.574219 L 33.78125 41.875 L 35.515625 36.546875 L 30.988281 33.25 L 36.585938 33.25 Z M 38.320312 27.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 38.320312 51.445312 L 40.035156 56.769531 L 45.625 56.769531 L 41.105469 60.0625 L 42.828125 65.390625 L 38.320312 62.105469 L 33.78125 65.390625 L 35.515625 60.0625 L 30.988281 56.769531 L 36.585938 56.769531 Z M 38.320312 51.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 38.320312 74.976562 L 40.035156 80.304688 L 45.625 80.304688 L 41.105469 83.597656 L 42.828125 88.90625 L 38.320312 85.625 L 33.78125 88.90625 L 35.515625 83.597656 L 30.988281 80.304688 L 36.585938 80.304688 Z M 38.320312 74.976562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 38.320312 98.5 L 40.035156 103.820312 L 45.625 103.820312 L 41.105469 107.113281 L 42.828125 112.4375 L 38.320312 109.140625 L 33.78125 112.4375 L 35.515625 107.113281 L 30.988281 103.820312 L 36.585938 103.820312 Z M 38.320312 98.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 54.902344 15.527344 L 56.625 20.863281 L 62.230469 20.863281 L 57.695312 24.144531 L 59.421875 29.484375 L 54.902344 26.171875 L 50.363281 29.484375 L 52.089844 24.144531 L 47.554688 20.863281 L 53.167969 20.863281 Z M 54.902344 15.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 54.902344 39.054688 L 56.625 44.382812 L 62.230469 44.382812 L 57.695312 47.679688 L 59.421875 53.003906 L 54.902344 49.707031 L 50.363281 53.003906 L 52.089844 47.679688 L 47.554688 44.382812 L 53.167969 44.382812 Z M 54.902344 39.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 54.902344 62.578125 L 56.625 67.898438 L 62.230469 67.898438 L 57.695312 71.195312 L 59.421875 76.519531 L 54.902344 73.222656 L 50.363281 76.519531 L 52.089844 71.195312 L 47.554688 67.898438 L 53.167969 67.898438 Z M 54.902344 62.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 54.902344 86.109375 L 56.625 91.433594 L 62.230469 91.433594 L 57.695312 94.726562 L 59.421875 100.035156 L 54.902344 96.757812 L 50.363281 100.035156 L 52.089844 94.726562 L 47.554688 91.433594 L 53.167969 91.433594 Z M 54.902344 86.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 54.902344 109.628906 L 56.625 114.949219 L 62.230469 114.949219 L 57.695312 118.25 L 59.421875 123.570312 L 54.902344 120.289062 L 50.363281 123.570312 L 52.089844 118.25 L 47.554688 114.949219 L 53.167969 114.949219 Z M 54.902344 109.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 71.261719 27.929688 L 73.003906 33.25 L 78.59375 33.25 L 74.066406 36.546875 L 75.800781 41.875 L 71.261719 38.574219 L 66.71875 41.875 L 68.46875 36.546875 L 63.949219 33.25 L 69.53125 33.25 Z M 71.261719 27.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 71.261719 51.445312 L 73.003906 56.769531 L 78.59375 56.769531 L 74.066406 60.0625 L 75.800781 65.390625 L 71.261719 62.105469 L 66.71875 65.390625 L 68.46875 60.0625 L 63.949219 56.769531 L 69.53125 56.769531 Z M 71.261719 51.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 71.261719 74.976562 L 73.003906 80.304688 L 78.59375 80.304688 L 74.066406 83.597656 L 75.800781 88.90625 L 71.261719 85.625 L 66.71875 88.90625 L 68.46875 83.597656 L 63.949219 80.304688 L 69.53125 80.304688 Z M 71.261719 74.976562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 71.261719 98.5 L 73.003906 103.820312 L 78.59375 103.820312 L 74.066406 107.113281 L 75.800781 112.4375 L 71.261719 109.140625 L 66.71875 112.4375 L 68.46875 107.113281 L 63.949219 103.820312 L 69.53125 103.820312 Z M 71.261719 98.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 87.84375 15.527344 L 89.585938 20.863281 L 95.175781 20.863281 L 90.648438 24.144531 L 92.363281 29.484375 L 87.84375 26.171875 L 83.324219 29.484375 L 85.066406 24.144531 L 80.53125 20.863281 L 86.121094 20.863281 Z M 87.84375 15.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 87.84375 39.054688 L 89.585938 44.382812 L 95.175781 44.382812 L 90.648438 47.679688 L 92.363281 53.003906 L 87.84375 49.707031 L 83.324219 53.003906 L 85.066406 47.679688 L 80.53125 44.382812 L 86.121094 44.382812 Z M 87.84375 39.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 87.84375 62.578125 L 89.585938 67.898438 L 95.175781 67.898438 L 90.648438 71.195312 L 92.363281 76.519531 L 87.84375 73.222656 L 83.324219 76.519531 L 85.066406 71.195312 L 80.53125 67.898438 L 86.121094 67.898438 Z M 87.84375 62.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 87.84375 86.109375 L 89.585938 91.433594 L 95.175781 91.433594 L 90.648438 94.726562 L 92.363281 100.035156 L 87.84375 96.757812 L 83.324219 100.035156 L 85.066406 94.726562 L 80.53125 91.433594 L 86.121094 91.433594 Z M 87.84375 86.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 87.84375 109.628906 L 89.585938 114.949219 L 95.175781 114.949219 L 90.648438 118.25 L 92.363281 123.570312 L 87.84375 120.289062 L 83.324219 123.570312 L 85.066406 118.25 L 80.53125 114.949219 L 86.121094 114.949219 Z M 87.84375 109.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 104.214844 27.929688 L 105.957031 33.25 L 111.546875 33.25 L 107.027344 36.546875 L 108.75 41.875 L 104.214844 38.574219 L 99.695312 41.875 L 101.402344 36.546875 L 96.902344 33.25 L 102.492188 33.25 Z M 104.214844 27.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 104.214844 51.445312 L 105.957031 56.769531 L 111.546875 56.769531 L 107.027344 60.0625 L 108.75 65.390625 L 104.214844 62.105469 L 99.695312 65.390625 L 101.402344 60.0625 L 96.902344 56.769531 L 102.492188 56.769531 Z M 104.214844 51.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 104.214844 74.976562 L 105.957031 80.304688 L 111.546875 80.304688 L 107.027344 83.597656 L 108.75 88.90625 L 104.214844 85.625 L 99.695312 88.90625 L 101.402344 83.597656 L 96.902344 80.304688 L 102.492188 80.304688 Z M 104.214844 74.976562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 104.214844 98.5 L 105.957031 103.820312 L 111.546875 103.820312 L 107.027344 107.113281 L 108.75 112.4375 L 104.214844 109.140625 L 99.695312 112.4375 L 101.402344 107.113281 L 96.902344 103.820312 L 102.492188 103.820312 Z M 104.214844 98.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 120.804688 15.527344 L 122.53125 20.863281 L 128.136719 20.863281 L 123.601562 24.144531 L 125.34375 29.484375 L 120.804688 26.171875 L 116.277344 29.484375 L 118.011719 24.144531 L 113.472656 20.863281 L 119.074219 20.863281 Z M 120.804688 15.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 120.804688 39.054688 L 122.53125 44.382812 L 128.136719 44.382812 L 123.601562 47.679688 L 125.34375 53.003906 L 120.804688 49.707031 L 116.277344 53.003906 L 118.011719 47.679688 L 113.472656 44.382812 L 119.074219 44.382812 Z M 120.804688 39.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 120.804688 62.578125 L 122.53125 67.898438 L 128.136719 67.898438 L 123.601562 71.195312 L 125.34375 76.519531 L 120.804688 73.222656 L 116.277344 76.519531 L 118.011719 71.195312 L 113.472656 67.898438 L 119.074219 67.898438 Z M 120.804688 62.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 120.804688 86.109375 L 122.53125 91.433594 L 128.136719 91.433594 L 123.601562 94.726562 L 125.34375 100.035156 L 120.804688 96.757812 L 116.277344 100.035156 L 118.011719 94.726562 L 113.472656 91.433594 L 119.074219 91.433594 Z M 120.804688 86.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 120.804688 109.628906 L 122.53125 114.949219 L 128.136719 114.949219 L 123.601562 118.25 L 125.34375 123.570312 L 120.804688 120.289062 L 116.277344 123.570312 L 118.011719 118.25 L 113.472656 114.949219 L 119.074219 114.949219 Z M 120.804688 109.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 137.191406 27.929688 L 138.917969 33.25 L 144.5 33.25 L 139.972656 36.546875 L 141.710938 41.875 L 137.191406 38.574219 L 132.640625 41.875 L 134.382812 36.546875 L 129.863281 33.25 L 135.453125 33.25 Z M 137.191406 27.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 137.191406 51.445312 L 138.917969 56.769531 L 144.5 56.769531 L 139.972656 60.0625 L 141.710938 65.390625 L 137.191406 62.105469 L 132.640625 65.390625 L 134.382812 60.0625 L 129.863281 56.769531 L 135.453125 56.769531 Z M 137.191406 51.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 137.191406 74.976562 L 138.917969 80.304688 L 144.5 80.304688 L 139.972656 83.597656 L 141.710938 88.90625 L 137.191406 85.625 L 132.640625 88.90625 L 134.382812 83.597656 L 129.863281 80.304688 L 135.453125 80.304688 Z M 137.191406 74.976562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 137.191406 98.5 L 138.917969 103.820312 L 144.5 103.820312 L 139.972656 107.113281 L 141.710938 112.4375 L 137.191406 109.140625 L 132.640625 112.4375 L 134.382812 107.113281 L 129.863281 103.820312 L 135.453125 103.820312 Z M 137.191406 98.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 153.765625 15.527344 L 155.492188 20.863281 L 161.082031 20.863281 L 156.578125 24.144531 L 158.296875 29.484375 L 153.765625 26.171875 L 149.246094 29.484375 L 150.972656 24.144531 L 146.4375 20.863281 L 152.027344 20.863281 Z M 153.765625 15.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 153.765625 39.054688 L 155.492188 44.382812 L 161.082031 44.382812 L 156.578125 47.679688 L 158.296875 53.003906 L 153.765625 49.707031 L 149.246094 53.003906 L 150.972656 47.679688 L 146.4375 44.382812 L 152.027344 44.382812 Z M 153.765625 39.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 153.765625 62.578125 L 155.492188 67.898438 L 161.082031 67.898438 L 156.578125 71.195312 L 158.296875 76.519531 L 153.765625 73.222656 L 149.246094 76.519531 L 150.972656 71.195312 L 146.4375 67.898438 L 152.027344 67.898438 Z M 153.765625 62.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 153.765625 86.109375 L 155.492188 91.433594 L 161.082031 91.433594 L 156.578125 94.726562 L 158.296875 100.035156 L 153.765625 96.757812 L 149.246094 100.035156 L 150.972656 94.726562 L 146.4375 91.433594 L 152.027344 91.433594 Z M 153.765625 86.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 153.765625 109.628906 L 155.492188 114.949219 L 161.082031 114.949219 L 156.578125 118.25 L 158.296875 123.570312 L 153.765625 120.289062 L 149.246094 123.570312 L 150.972656 118.25 L 146.4375 114.949219 L 152.027344 114.949219 Z M 153.765625 109.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 170.144531 27.929688 L 171.859375 33.25 L 177.46875 33.25 L 172.941406 36.546875 L 174.65625 41.875 L 170.144531 38.574219 L 165.601562 41.875 L 167.324219 36.546875 L 162.824219 33.25 L 168.414062 33.25 Z M 170.144531 27.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 170.144531 51.445312 L 171.859375 56.769531 L 177.46875 56.769531 L 172.941406 60.0625 L 174.65625 65.390625 L 170.144531 62.105469 L 165.601562 65.390625 L 167.324219 60.0625 L 162.824219 56.769531 L 168.414062 56.769531 Z M 170.144531 51.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 170.144531 74.976562 L 171.859375 80.304688 L 177.46875 80.304688 L 172.941406 83.597656 L 174.65625 88.90625 L 170.144531 85.625 L 165.601562 88.90625 L 167.324219 83.597656 L 162.824219 80.304688 L 168.414062 80.304688 Z M 170.144531 74.976562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 170.144531 98.5 L 171.859375 103.820312 L 177.46875 103.820312 L 172.941406 107.113281 L 174.65625 112.4375 L 170.144531 109.140625 L 165.601562 112.4375 L 167.324219 107.113281 L 162.824219 103.820312 L 168.414062 103.820312 Z M 170.144531 98.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 186.71875 15.527344 L 188.453125 20.863281 L 194.042969 20.863281 L 189.515625 24.144531 L 191.246094 29.484375 L 186.71875 26.171875 L 182.183594 29.484375 L 183.925781 24.144531 L 179.386719 20.863281 L 184.996094 20.863281 Z M 186.71875 15.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 186.71875 39.054688 L 188.453125 44.382812 L 194.042969 44.382812 L 189.515625 47.679688 L 191.246094 53.003906 L 186.71875 49.707031 L 182.183594 53.003906 L 183.925781 47.679688 L 179.386719 44.382812 L 184.996094 44.382812 Z M 186.71875 39.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 186.71875 62.578125 L 188.453125 67.898438 L 194.042969 67.898438 L 189.515625 71.195312 L 191.246094 76.519531 L 186.71875 73.222656 L 182.183594 76.519531 L 183.925781 71.195312 L 179.386719 67.898438 L 184.996094 67.898438 Z M 186.71875 62.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 186.71875 86.109375 L 188.453125 91.433594 L 194.042969 91.433594 L 189.515625 94.726562 L 191.246094 100.035156 L 186.71875 96.757812 L 182.183594 100.035156 L 183.925781 94.726562 L 179.386719 91.433594 L 184.996094 91.433594 Z M 186.71875 86.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 186.71875 109.628906 L 188.453125 114.949219 L 194.042969 114.949219 L 189.515625 118.25 L 191.246094 123.570312 L 186.71875 120.289062 L 182.183594 123.570312 L 183.925781 118.25 L 179.386719 114.949219 L 184.996094 114.949219 Z M 186.71875 109.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usaFlag.2de9b734b0c4f9495aceac134e875e4c.svg";
export { ForwardRef as ReactComponent };